<div class="working-list-container">
  <p class="text-muted">Add details for every item in the list. After saving you can see checklist details.</p>
  
  <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col" width="3%">#</th>
              <th scope="col" width="20%">Name</th>
          <th scope="col" width="20%">Product</th>
          <th scope="col" width="15%">Platform</th>
          <th scope="col" width="20%">Checklist</th>
          <th scope="col" width="5%">Time</th>
          <th scope="col" width="23%">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (item of workingListItems; track item.id; let i = $index) {
          <tr>
            <td class="text-center align-middle">
              {{i+1}}
            </td>
            <td class="align-middle">
              <input-field
                [inputFormControl]="getItemNameControl(item)"
                [placeholder]="'Enter item name'"
                (valueChange)="updateItemField(item, 'name', $event)">
              </input-field>
            </td>
            <td class="align-middle">
              <input-field
                [inputFormControl]="getItemProductControl(item)"
                [placeholder]="'Enter product name'"
                (valueChange)="updateItemField(item, 'product', $event)"
                [readonly]="true">
              </input-field>
            </td>
            <td class="align-middle">
              <select-field
                [selectFormControl]="getItemPlatformControl(item)"
                [options]="platformOptions"
                (valueChange)="updateItemField(item, 'platform', $event)">
              </select-field>
            </td>
            <td class="align-middle">
              <select-field
                [selectFormControl]="getItemChecklistControl(item)"
                [options]="getChecklistOptionsForItem(item)"
                (valueChange)="updateItemField(item, 'checklist', $event)">
              </select-field>
            </td>
            <td class="align-middle">
              <input-field
                [inputFormControl]="getItemTimeControl(item)"
                [placeholder]="'--:--'"
                [type]="'time'"
                (valueChange)="updateItemField(item, 'time', $event)">
              </input-field>
            </td>
            <td class="align-middle">
              <div class="d-flex gap-1">
                <button class="btn btn-primary flex-grow-1" 
                        (click)="createChecklist(i)" 
                        [disabled]="!isCreateChecklistEnabled(item)" 
                        title="Create Checklist">
                  @if (item.isCreatingChecklist) {
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  }
                  {{ getCreateChecklistButtonText(item) }}
                </button>
                <button class="btn btn-danger" (click)="removeItem(i)" title="Delete item" [disabled]="item.isCreatingChecklist">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
          }
      </tbody>
    </table>
  </div>
  
  <div class="row mt-4">
    <div class="col-md-6">
      <div class="login-data-section">
        <h5 class="section-title">LOGIN DATA</h5>
        <textarea-field
          [textareaFormControl]="getLoginDataInput()"
          [placeholder]="'Enter login data'"
          [height]="150"
          (valueChange)="updateLoginData($event)">
        </textarea-field>
      </div>
    </div>
    
    <div class="col-md-6">
      <div class="notes-section">
        <h5 class="section-title">NOTES</h5>
        <textarea-field
          [textareaFormControl]="getNotesInput()"
          [placeholder]="'Enter notes'"
          [height]="150"
          (valueChange)="updateNotes($event)">
        </textarea-field>
      </div>
    </div>
  </div>
</div>
